export const NOTIFICATION_EVENTS = {
  SEND: 'notification:send'
};
